import content from "app-content";
import PropTypes from "prop-types";
import ProductSelect from "../ProductSelect";
import getOptions from "./getOptions";
import { isDisabled } from "./isDisabled";
import { SIZE_PICKER_DEFAULT_VALUE } from "./constants";

const ProductSizeSelect = ({
  isOneSize,
  isNoSize,
  variantId,
  variants,
  isForceDisabled,
  onChange,
  ...rest
}) => (
  <ProductSelect
    options={getOptions({
      isOneSize,
      isNoSize,
      variantId,
      variants
    })}
    label={content.saved_items_accessibility_size_picker}
    disabled={isDisabled({
      isForceDisabled,
      isOneSize,
      isNoSize
    })}
    value={variantId !== null ? `${variantId}` : SIZE_PICKER_DEFAULT_VALUE}
    onChange={onChange}
    {...rest}
  />
);

ProductSizeSelect.propTypes = {
  variantId: PropTypes.number,
  isOneSize: PropTypes.bool.isRequired,
  isNoSize: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isForceDisabled: PropTypes.bool.isRequired,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      price: PropTypes.object.isRequired,
      displaySizeText: PropTypes.string.isRequired,
      isVariantInStock: PropTypes.bool.isRequired
    })
  ).isRequired
};

export default ProductSizeSelect;
